import { put } from 'redux-saga/effects';
import { BASEURL } from '../../../BaseUrl/BaseUrl';
import axios from '../../../utils/axios';
import { getErrorMessage, hasError } from '../../slices/responseStatus';
import { downloadAttendanceReport, getAttendanceList, startLoading } from '../../slices/employee';
import { isLogout } from '../../slices/login';

function buildReportQuery({ startDate, endDate, page, limit, searchText }) {
  const params = new URLSearchParams({ startDate, endDate });
  if (page != null && limit != null) {
    params.set('page', String(page));
    params.set('limit', String(limit));
  }
  const trimmed = typeof searchText === 'string' ? searchText.trim() : '';
  if (trimmed.length >= 3) {
    params.set('searchText', trimmed);
  }
  return params.toString();
}

function parseAttendancePayload(response) {
  const attendance = response?.data?.data?.Attendance;
  const attendanceList = attendance?.attendanceList ?? [];
  const total = attendance?.totalRowsValue ?? attendance?.total ?? attendance?.count ?? attendanceList.length;
  return { attendanceList, total };
}

export function* employeeAttendanceListSaga(state) {
  try {
    const { startDate, endDate, page, limit, searchText } = state;

    yield put(hasError(false));
    yield put(startLoading(true));
    const Token = window.localStorage.getItem('auth-token');
    const query = buildReportQuery({ startDate, endDate, page, limit, searchText });
    const response = yield axios.get(`${BASEURL}/attendance/report?${query}`, {
      headers: {
        'x-auth-token': `${Token}`,
      },
    });
    const { attendanceList, total } = parseAttendancePayload(response);

    yield put(
      getAttendanceList({
        list: attendanceList === undefined ? [] : attendanceList,
        total,
      })
    );
  } catch (error) {
    yield put(startLoading(false));
    yield put(hasError(true));
    yield put(getErrorMessage(error.error.message));
    if (error.error?.statusCode === 401) {
      yield put(isLogout(true));
    }
  }
}

/** Full report for Excel export (no page/limit). */
export function* employeeAttendanceExportSaga(state) {
  try {
    const { startDate, endDate } = state;

    yield put(hasError(false));
    const Token = window.localStorage.getItem('auth-token');
    const query = buildReportQuery({ startDate, endDate });
    const response = yield axios.get(`${BASEURL}/attendance/report?${query}`, {
      headers: {
        'x-auth-token': `${Token}`,
      },
    });
    const { attendanceList } = parseAttendancePayload(response);

    yield put(downloadAttendanceReport(attendanceList === undefined ? [] : attendanceList));
  } catch (error) {
    yield put(hasError(true));
    yield put(getErrorMessage(error.error.message));
    if (error.error?.statusCode === 401) {
      yield put(isLogout(true));
    }
  }
}
